<template>
    <div class="application">
        <h1>Application</h1>
        <p>A software application executes tasks from processes.</p>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "Process",
});
</script>
